<template>
  <div v-if="show_body">
    <!-- 测评答题 -->
    <!-- 他评必传的参数 data  pattern  taTextObject  intro -->
    <answer-questions-check :cid_type="'ceping88'" :array="data.list" :interruptShow="interruptShow" :data_="data" :pattern='pattern' :taTextObject="taTextObject" @interruptHandle="interruptHandle"  :intro="data.intro?data.intro.split('\r'):[]"  @saveReportHandle="saveReportHandle"></answer-questions-check>
    <!-- 自己 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="kc_show">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <!-- <img src="../../../assets/cep_ewm.png" /> -->
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
    <!-- 未购买 -->
    <van-popup class="pub_alert" v-model="is_buy" :close-on-click-overlay="false">
      <div class="confirm_box">
        <h2>此测评属于最佳工作模式课程，快去购买课程测评吧</h2>
        <div class="btn_group">
          <router-link class="confirm" :to="{
            path:'/course_details',
            query:{
              bid:2
            }
          }">购买最佳工作模式课程</router-link>
        </div>
      </div>
    </van-popup>
    <!-- 判断链接是否失效 -->
    <van-popup class="pub_alert" v-model="failureShow" :close-on-click-overlay="false">
        <div class="confirm_box">
            <h2 class="on">{{failureMsg}}</h2>
        </div>
    </van-popup>

    <!-- 填写个人资料 -->
    <div v-if="userInfoBool" :class="['save-userinfo',userInfoBool?'on':'']">
      <div class="u-title">个人信息提交</div>
      <div>
        <div v-for="(item,index) in Object.keys(extraObj)" :class="['u-input',(item[0] == '_')?'on':'']">
          <label v-html="nl2br(extraObj[item])"></label>
          <div class="ra" v-if="item=='_interest'">
            <!-- 多选 -->
            <van-radio-group v-model="extra[item]" >
              <van-radio :class="['radio',true?'on':false]" checked-color="#eb5032" :name="'不想了解'">不想了解</van-radio>
              <van-radio :class="['radio',true?'on':false]" checked-color="#eb5032" :name="'有点感兴趣'">有点感兴趣</van-radio>
              <van-radio :class="['radio',true?'on':false]" checked-color="#eb5032" :name="'非常感兴趣'">非常感兴趣</van-radio>
            </van-radio-group>
          </div>
          <div class="ra" v-else-if="item=='_identity'">
            <!-- 单选 -->
            <van-radio-group v-model="extra[item]" >
              <van-radio :class="['radio',true?'on':false]" checked-color="#eb5032" :name="'在校学生'">在校学生</van-radio>
              <van-radio :class="['radio',true?'on':false]" checked-color="#eb5032" :name="'已毕业/已就业'">已毕业/已就业</van-radio>
            </van-radio-group>
          </div>
          <div class="ra" v-else-if="item[0] == '_'">
            <!-- 单选 -->
            <van-radio-group class="row" v-model="extra[item]" >
              <van-radio :class="['radio',true?'on':false]" checked-color="#eb5032" :name="'是'">是</van-radio>
              <van-radio :class="['radio',true?'on':false]" checked-color="#eb5032" :name="'否'">否</van-radio>
            </van-radio-group>
          </div>
          <input v-else type="text" v-model="extra[item]" :placeholder="'请输入'+extraObj[item]" />
        </div>
      </div>
      <!--  -->
      <a class="u-btn" @click="saveUserInfo()">提交</a>
    </div>

    <!-- <answer-collect :cid="data.cid" :query="$route.query" :extraObj="extraObj" v-if="userInfoBool" @saveuserinfo="saveUserInfo"></answer-collect> -->
  </div>
</template>
<script>
import { ceping88_index, ceping88_answer,get_extra_info,ceping_event} from '@/api/measurement'
import AnswerQuestionsCheck from "@c/measurement/answer-questions-check";
// import AnswerCollect from "@c/measurement/answer-collect";

import {
  queryString,
  getStorage,
  setStorage,
  deleteStorage
} from '@/utils/tools'
import { phoneValidation } from '@/utils/validation'
import { shareCon} from '@/utils/wxconfig'
export default {
  data() {
      return {
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        },
        show_body: false,
        qrcode: "",
        //
        nickname: "",
        kc_show: false,
        // 模式
        pattern: false,
        data: {},
        // 上一页面路由
        formPath: '',
        failureShow:false,
        interruptShow:false,
        failureMsg:'',
        // 他评显示文案
        taTextObject:{},
       
        // 存储答题数据
        extra:{},
        extraObj:{},
        userInfoBool:false,
        queArr:[]
      }
    },
    components: {
      AnswerQuestionsCheck,
      // AnswerCollect,
    },
    computed: {
      is_buy(){
        return (!this.data.is_buy && !this.data.msg && !this.pattern)
      },
      // 文字换行
      textToHtml(){
        return function(text){
          let arr = text.split('')
          arr =  arr.map((v,index)=>{
            // return index==3?v+'<br/>':
            return ((index==arr.length-1)?v+'：':v)
          });
          return arr.join('');
        }
      }
    },
    // mounted() {
    //   window.vm = this;
    // },
    methods: {
      nl2br(str) {
        console.log(str)
        console.log(str.replace(/\n/g, '<br>'))
        return str.replace(/\n/g, '<br>');
      },
      interruptHandle(bool){
        this.interruptShow = bool;
      },
      // 提交个人信息和答题数据
      saveUserInfo(extra){
        if(extra) {
          this.extra = extra;
        }
        
        let arr  = this.queArr;
        let obj = {
          answer: JSON.stringify(arr)
        };
        if(this.$route.query.sid){
          obj['sid'] = this.$route.query.sid;
        }
        for(let i=0;i<Object.keys(this.extraObj).length;i++){
          let item = Object.keys(this.extraObj)[i];
          if(!this.extra[item]){
            this.$toast(`${this.extraObj[item]}不能为空！`);
            return
          }else if(!phoneValidation(this.extra.phone)){
            this.$toast('手机号格式不正确！');
            return
          }else{
            obj[item] = this.extra[item];
          }
        }

        this.$toast.loading({
          mask: true,
          message: "提交中..."
        });
        // 
        ceping88_answer(obj).then((data) => {
          // 隐藏提交信息窗口
          // this.userInfoBool = false;
          if (this.subscribe) {
            // 提交删除缓存
            deleteStorage(this.$route.path);
            let q = this.$route.query;
            this.$toast('提交成功！');
            setTimeout(() => {
              if (this.formPath === '/ceping88_report') {
                this.$router.back();
              } else {
                q['uid'] = data.uid;
                this.$router.push({
                  path: '/ceping88_report',
                  query: q
                })
              }
            }, 200)
            
          } else {
            this.kc_show = true;
          }
        });
      },
      /*
       *@param: arr
       *@return: 
       *@Description: 获得提交的答题数据
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-11-01 15:28:13
      */
      saveReportHandle(arr){
        let bool = true;
        get_extra_info().then(data=>{
          for(let i=0;i<Object.keys(this.extraObj).length;i++){
            let item = Object.keys(this.extraObj)[i];
            if(data.extra[item]){
              this.extra[item] = data.extra[item];
            }else{
              bool = false;

            }
          }
          this.queArr = arr;
          // if(bool){
          //   this.saveUserInfo();
          // }else{
            this.userInfoBool = true;
          // }
        });
      },
      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
          let q = this.$route.query;
          
          let obj = {
            share_uid: q.share_uid || "",
            channel: q.channel || ""
          };
          if(this.$route.query.code){
            obj['code'] = this.$route.query.code;
          }
          ceping88_index(obj).then((data) => {
              this.data = data;
              if (data.code != 10002) {
                this.type_obj.evaluation_id = data.cid;          
                this.type_obj.evaluation_name = data.headtitle;          
                this.type_obj.evaluation_user_id = data.uid;          
                this.type_obj.nickname = data.nickname;          
                this.type_obj.path = this.$route.path;       
                shareCon("ceping73", this, this.type_obj);
                //判断是否是已购买课程并且链接已使用或者失效
                if(data.msg){
                  this.failureMsg = data.msg;
                  this.failureShow = true;
                }else{
                  //判断是否是已购买课程并且有本地缓存
                  if (data.is_buy && window.localStorage.getItem(this.$route.path)) {
                    this.interruptShow = true;
                  }
                  this.extraObj = data.extra || {};

                  let extraKeys = Object.keys(this.extraObj);
                  for(let i = 0; i < extraKeys.length; i++) {
                    let extra_key = extraKeys[i];
                    this.$set(this.extra, extra_key, this.extra[extra_key] || '');
                  }

                  // 设置数据
                  this.initCptData(data);
                }
                // 显示
                this.show_body = true;

              } else {
                if (this.formPath === '/ceping88_report') {
                  this.$router.back();
                } else {
                  this.$router.push({
                    path:'/ceping88_report',
                    query:this.$route.query
                  });
                }

              };
              //关闭加载中
              this.$emit('loadingHandle',false);

              ceping_event({ lead_sid: this.$route.query.lead_sid,
                cid: data.cid,
                event: 'ViewIndex',
              }).then(res=>{
                // 页面访问统计
              });

              // 神策统计--打开页面时触发
              // sensors.track('evaluationPage', {
              //   evaluation_id: String(data.cid),
              //   evaluation_name: data.headtitle,
              //   evaluation_url: window.location.href,
              //   evaluation_page_title: data.headtitle,
              //   share_user_id: this.$route.query.share_uid ? this.$route.query.share_uid : "",
              //   channel_name: this.$route.query.channel ? this.$route.query.channel : ""
              // })
            })

      },
      initCptData(data) {
        this.subscribe = data.subscribe;
        if (!data.need_subscribe) {
          this.subscribe = true;
        }
        this.qrcode = data.qrcode;
        //
        this.nickname = data.nickname;
        document.title = data.headtitle;
      },
      
    },
    beforeRouteEnter(to, from, next) {
      next(vm => { //  这里的vm指的就是vue实例，可以用来当做this使用
        vm.formPath = from.path;
      })
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.confirm_box {
  padding: 50px 40px;
  border-radius: 12px;
}

.confirm_box h3 {
  margin: 10px 0;
  color: #999;
  font-size: 26px;
  text-align: center;
}

.confirm_box a.cancel {
  color: #fff;
  background-color: #EB5032;
  line-height: 60px;
  text-align: center;
  font-size: 28px;
  display: block;
  margin: 0 auto;
  margin-top: 40px;
  border-radius: 8px
}

.grouping .van-cell .van-cell__value input {
  border: 2px solid #ccc;
  border-radius: 12px;
  font-size: 26px;
  color: #333;
}
.save-userinfo{
  position: fixed;
  width: 100%;
  max-width: 750px;
  left: -100%;
  transform: translateX(-50%);
  top: 0;
  height: 100%;
  background-color: #ffffff;
  padding: 150px 60px 100px;
  overflow: auto;
  .u-title{
    font-size: 36px;
    color: #333;
    text-align: center;
    margin-bottom: 80px;
    font-weight: bold;
  }
  .u-input{
    display: flex;
    align-items: center;
    font-size: 30px;
    margin-bottom: 50px;
    
    label{
      display: block;
      width: 150px;
      text-align: justify;
      text-align-last: justify;
      padding-right: 50px;
    }
    input{
      line-height: 70px;
      flex: 1;
      border:2px solid #F57F17;
      border-radius: 15px;
      padding-left: 10px;
      font-size: 26px;
      background-color: #ffffff;
    }
  }
  .u-input:last-child:not(.on){
    margin-bottom: 200px;
  }
  .u-btn{
    display: block;
    margin: 0 auto;
    width: 100%;
    border-radius: 15px;
    border: none;
    background-color: #F57F17;
    font-size: 32px;
    text-align: center;
    color: #ffffff;
    line-height: 80px;
  }
}
.save-userinfo.on{
  left: 50%;
}
.progress {
  position: fixed;
  height: 8px;
  left: 0;
  top: 0;
  z-index: 3;
  background: red;
  transition: all .3s;
}

.pg-num {
  position: fixed;
  padding: 10px;
  top: 10px;
  right: 10px;
  z-index: 4;
  background: red;
  transition: all .3s;
  color: #fff;
  border-radius: 30px;
}
.m-error{
  bottom: 60px;
  position: fixed;
  width: 80px;
  line-height: 80px;
  height: 80px;
  text-align: center;
  right: 40px;
  z-index: 4;
  background: #fff;
  transition: all .3s;
  color: #F57F17;
  border: 2px solid #F57F17;
  border-radius: 50%;
  box-sizing: border-box;
}
.error-pop{
  background: transparent;
}
.error{
  background-color: #ffffff;
  width: 690px;
  padding: 30px;
  border-radius: 15px;
  h3{
    font-size: 34px;
    color: #333;
  }
  textarea{
    margin: 40px auto 90px;
    resize:none;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 8px;
    line-height: 39px;
    width: 100%;
    background-color: #f5f5f5;
  }
  .error-footer{
    border-top:1px solid #d3d3d3;
    display: flex;
    position: absolute;
    bottom:0;
    width: 100%;
    left: 0;
    line-height: 90px;
    a{
      flex: 1;
      text-align: center;
      font-size: 34px;
      color: #333;
      &:nth-child(1){
        color: #EB5032;
      }
      &:nth-child(2){
        color: #666666;
        border-left: 1px solid #d3d3d3;
      }
    }
  }
}

.mt32 {
  margin-top: 32px;
}

.pt32 {
  padding-top: 32px;
}

.pb-public {
  padding: changeRem(0.425)+px;
}


.pop {
  img {
    max-width: 8rem;
  }
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.confirm_box {
  h2 {
    padding: 40px 30px;
  }
  h2.on {
    padding: 60px 30px;
  }
  p {
    margin-bottom: 50px;
    font-size: 26px;
    color: #666;
  }
  .btn_group {
    .confirm {
      color: #999999;
    }
    .cancel {
      color: #EB5032;
    }
  }
}

// 弹出开始测评说明
.answer-sheet {
  transition: all 2s;
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.answer-sheet.on {
  left: -1500px;
}
.save-userinfo{
  position: fixed;
  width: 100%;
  max-width: 750px;
  left: -100%;
  transform: translateX(-50%);
  top: 0;
  height: 100%;
  background-color: #ffffff;
  padding: 150px 60px 100px;
  .u-title{
    font-size: 36px;
    color: #333;
    text-align: center;
    margin-bottom: 80px;
    font-weight: bold;
  }
  .u-input{
    display: flex;
    align-items: center;
    font-size: 30px;
    margin-bottom: 50px;
    label{
      display: block;
      width: 150px;
      text-align: right;
    }
    input{
      line-height: 70px;
      flex: 1;
      border:2px solid #F57F17;
      border-radius: 15px;
      padding-left: 10px;
      font-size: 26px;
      background-color: #ffffff;
    }
  }
  .u-input.on{
    flex-direction: column;
    label{
      display: block;
      margin-right: auto;
      white-space: nowrap;
    }
    .ra{
      width:100%;
      line-height:80px;
      padding-left:150px;
      padding-top: 20px;
    }
  }
  .u-btn{
    display: block;
    margin: 0 auto;
    width: 100%;
    border-radius: 15px;
    border: none;
    background-color: #F57F17;
    font-size: 32px;
    text-align: center;
    color: #ffffff;
    line-height: 80px;
  }
}
.save-userinfo.on{
  left: 50%;
}
</style>
<style lang="scss">
  .ra .row{
    display: flex;
    .radio{
      margin-right: 80px;
    }
  }
</style>